/* Published companion catalog. Search/filter/pagination are local; no tracking. */
document.querySelectorAll('[data-companion-catalog]').forEach(catalog => {
  const cards = [...catalog.querySelectorAll('[data-catalog-category]')];
  const buttons = [...catalog.querySelectorAll('[data-native-filter]')];
  const search = catalog.querySelector('[data-catalog-search]');
  const count = catalog.querySelector('[data-native-count]');
  const pager = catalog.querySelector('[data-catalog-pagination]');
  const pageLabel = catalog.querySelector('[data-native-page-label]');
  const empty = catalog.querySelector('[data-catalog-empty]');
  const pageSize = 12;
  let category = 'all', page = 1;
  const normalize = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase('en').trim();
  function render() {
    const query = normalize(search.value);
    const matches = cards.filter(card => (category === 'all' || card.dataset.catalogCategory === category) && normalize(card.dataset.catalogName).includes(query));
    const pages = Math.max(1, Math.ceil(matches.length / pageSize));
    page = Math.min(page, pages);
    cards.forEach(card => { card.hidden = true; });
    matches.slice((page - 1) * pageSize, page * pageSize).forEach(card => { card.hidden = false; });
    count.textContent = `${matches.length} companion${matches.length > 1 ? 's' : ''}`;
    empty.hidden = matches.length > 0;
    pager.hidden = pages <= 1;
    pageLabel.textContent = `Page ${page} of ${pages}`;
    catalog.querySelector('[data-native-page="prev"]').disabled = page === 1;
    catalog.querySelector('[data-native-page="next"]').disabled = page === pages;
    buttons.forEach(button => { const selected = button.dataset.nativeFilter === category; button.classList.toggle('selected', selected); button.setAttribute('aria-pressed', String(selected)); });
  }
  buttons.forEach(button => button.addEventListener('click', () => { category = button.dataset.nativeFilter; page = 1; render(); }));
  search.addEventListener('input', () => { page = 1; render(); });
  catalog.querySelector('[data-catalog-reset]').addEventListener('click', () => { search.value = ''; category = 'all'; page = 1; render(); search.focus(); });
  catalog.querySelectorAll('[data-native-page]').forEach(button => button.addEventListener('click', () => {
    page += button.dataset.nativePage === 'next' ? 1 : -1;
    render();
    const first = catalog.querySelector('[data-catalog-category]:not([hidden]) a');
    first?.focus({preventScroll:true});
    catalog.querySelector('.collection-tools').scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'start'});
  }));
  render();
});
